import React from "react";

const DownloadProgress = ({ progress, theme, fileName, downloadInfo, formatBytes }) => {
  return (
    <div
      style={{
        background: theme === "dark-only" ? "#1d1e26" : "#fff",
        boxShadow:
          theme === "dark-only"
            ? "0 2px 6px rgba(255,255,255,0.1)"
            : "0 2px 6px rgba(0,0,0,0.15)",
        borderRadius: "0 0 8px 8px",
        padding: "0 16px 12px 16px",
        marginBottom: 10,
        transition: "all 0.3s ease",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: 4,
        }}
      >
        <span
          style={{
            fontSize: 11,
            color: theme === "dark-only" ? "#aaa" : "#666",
          }}
        >
          <i className="fa fa-spinner fa-spin" style={{ fontSize: 14 }}></i>{" "}
          Downloading...
        </span>
        <span
          style={{
            fontSize: 11,
            color: theme === "dark-only" ? "#aaa" : "#666",
          }}
        >
          {progress}%
        </span>
      </div>
      <div
        style={{
          width: "100%",
          height: "6px",
          backgroundColor: theme === "dark-only" ? "#2d2e3a" : "#e9ecef",
          borderRadius: "3px",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            width: `${progress}%`,
            height: "100%",
            backgroundColor: "#4299e1",
            borderRadius: "3px",
            transition: "width 0.3s ease",
          }}
        ></div>
      </div>
      {/* <div className="d-inline ml-2">
        <small style={{ color: "#ea6e00" }}>
          {downloadInfo.loaded > 0 && (
            <>
              <span>{formatBytes(downloadInfo.loaded)}</span> /{" "}
              <span>{formatBytes(downloadInfo.total)}</span>
            </>
          )}
          {downloadInfo.loaded === 0 && <>Initializing...</>}
        </small>
      </div> */}
    </div>
  );
};

export default DownloadProgress;
